"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLookModalVisibleState = void 0;
const react_1 = __importStar(require("react"));
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const RedirectTo_1 = __importDefault(require("../../../utilities/RedirectTo"));
const SaveInFolderModal_1 = __importDefault(require("./SaveInFolderModal"));
const look_1 = require("../../../server/models/look");
const folder_1 = require("../../../server/models/folder");
const components_1 = require("@alcumus/components");
const SingleSelectDropdown_1 = __importDefault(require("../shared/SingleSelectDropdown"));
const explore_1 = require("../../../server/models/explore");
const core_1 = require("@material-ui/core");
const EmbedRoute_1 = __importDefault(require("../../../routes/EmbedRoute"));
exports.createLookModalVisibleState = (0, recoil_1.atom)({
    key: 'createLookModalVisibleState',
    default: false,
});
const useStyles = (0, core_1.makeStyles)(() => ({
    formControl: {
        minWidth: 540,
        marginBottom: 24,
    },
    dashboardInput: {
        borderRadius: 8,
        border: `1px solid ${components_1.StyleVariables.colors.border.default}`,
    },
    dropdown: {
        height: 40,
    },
    mandatoryText: {
        color: components_1.StyleVariables.colors.text.critical,
        fontSize: `${components_1.StyleVariables.fonts.size.small} !important`,
        marginLeft: 2,
    },
    header: {
        display: 'flex',
        marginBottom: 5,
    },
}));
const CreateLookModal = ({ t, defaultFolderId, }) => {
    const classes = useStyles();
    const [, setIsLoadingData] = (0, react_1.useState)(false);
    const [visible, setVisible] = (0, recoil_1.useRecoilState)(exports.createLookModalVisibleState);
    const history = (0, react_router_dom_1.useHistory)();
    const isMounted = (0, react_1.useRef)(true);
    const [explores, setExplores] = (0, react_1.useState)([]);
    const [selected, setSelected] = (0, react_1.useState)();
    const getExplores = (0, react_1.useCallback)(() => {
        if (explores === undefined || explores.length === 0) {
            setIsLoadingData(true);
            (0, explore_1.getAllExplores)()
                .then((res) => {
                if (isMounted.current) {
                    setExplores(res);
                }
            })
                .finally(() => {
                if (isMounted.current) {
                    setIsLoadingData(false);
                }
            });
        }
    }, [explores, setExplores, visible]);
    (0, react_1.useEffect)(() => {
        getExplores();
        return () => {
            isMounted.current = false;
        };
    }, []);
    const successCallback = (look) => {
        (0, RedirectTo_1.default)({
            history,
            path: EmbedRoute_1.default.lookQueryString(look.folder.id, look.id),
        });
    };
    const handleChange = (event) => {
        setSelected({
            modelName: explores.find((e) => e.name === event.target?.value)?.modelName ?? '',
            dataSourceName: event.target?.value,
        });
    };
    const resetModalCallback = () => {
        setSelected({ modelName: '', dataSourceName: '' });
    };
    const saveInFolderModalProps = {
        defaultFolderId: defaultFolderId,
        formSubmitCallback: async (title, folderId) => await (0, look_1.createLook)(title, folderId.toString(), selected?.modelName, selected?.dataSourceName),
        successCallback: successCallback,
        successMessage: t('lookCreateSuccess'),
        failureMessage: t('lookCreateFail'),
        errorMessage: t('lookCreateError'),
        titleName: 'createLookTitle',
        titleValidationCallback: async (title, folderId) => await (0, folder_1.verifyLookNameUniqueIn)(title, folderId.toString()),
        notificationMessage: t('lookCreateNotify'),
        placeholder: t('lookCreatePlaceholder'),
        duplicateErrorMessage: t('lookCreateDuplicate'),
        autoFocus: true,
        headerText: t('lookCreateHeader'),
        primaryButtonText: t('lookCreateButton'),
        visible: visible,
        setVisible: (isVisible) => setVisible(isVisible),
        t: t,
        singleSelect: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classes.header },
                react_1.default.createElement(components_1.Text, { as: "span" }, t('lookDataSourceTitle')),
                react_1.default.createElement("label", { className: classes.mandatoryText }, '*')),
            react_1.default.createElement(SingleSelectDropdown_1.default, { value: selected?.dataSourceName ?? '', id: "data-source-chooser", handleChange: handleChange, formControlClassName: classes.formControl, dropdownClassName: classes.dropdown, placeholder: t('lookSelectADataSource') }, explores.map((child) => {
                return { value: child.name, displayName: child.label };
            })))),
        resetModalCallback: resetModalCallback,
    };
    return react_1.default.createElement(SaveInFolderModal_1.default, { ...saveInFolderModalProps });
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(CreateLookModal);
